<template>
  <div class="app">
    <p>Consigue nuestra app para dispositivos móviles</p>
    <div class="app-content">
      <div class="app-icon">
        <img
          width="50"
          src="../../assets/images/iconoApp.png"
          alt="Logo App TuAppto"
          class="logo"
        />
        <p class="login-main-tuappto">Tu<strong>Appto</strong></p>
      </div>
      <div class="app-buttons">
        <img
          width="70"
          src="../../assets/images/googlePlay.png"
          alt="Google Play"
          class="google"
        />
        <img
          width="70"
          src="../../assets/images/appleStore.png"
          alt="Apple Store"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.app {
  text-align: center;
}
.app > p {
  color: var(--primary-dark);
  font-size: 1.2rem;
}
.app-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2rem 2rem;
}
.app-icon {
  display: flex;
  align-items: center;
}
.app-icon > .logo {
  border: 4px solid var(--primary-dark);
  border-radius: .7rem;
  background-color: var(--primary-dark);
}
.app-icon > p {
  margin-left: .5rem;
  font-size: 1.5rem;
  color: var(--primary-dark);
}
.app-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.app-buttons > .google {
  margin-right: .5rem;
}
@media screen and (min-width: 500px) {
  .app-content {
    margin: 2rem 6rem
  }
}
@media screen and (min-width: 768px) {
  .app-content {
    margin: 2rem 12rem
  }
}
@media screen and (min-width: 992px) {
  .app {
    display: none;
  }
}
</style>